import { initializeApp } from 'firebase/app';
import {
    getAuth,
    connectAuthEmulator,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
} from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { Analytics, getAnalytics } from 'firebase/analytics';
import { isSupported as isAnalyticsSupported } from 'firebase/analytics';
import { initializeFirestoreData } from './init-firestore';
import { IS_EMULATOR_MODE } from '../constants';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    // measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

let analytics: Analytics | null = null;
if (window.location.hostname === 'localhost') {
    analytics = null;
} else {
    isAnalyticsSupported().then((supported) => {
        if (supported) {
            analytics = getAnalytics(app);
        } else {
            console.warn('Firebase Analytics is not supported in this environment.');
        }
    });
}

// Add data to Firestore
const db = getFirestore(app, process.env.REACT_APP_FIRESTORE_DATABASE_ID || '');

// Use firebase auth emulator for local development
const auth = getAuth(app);
const REACT_APP_FIRESTORE_AUTH_EMULATOR_HOST = process.env
    .REACT_APP_FIRESTORE_AUTH_EMULATOR_HOST as string;

if (IS_EMULATOR_MODE) {
    console.log('Connecting to Auth emulator...');
    connectAuthEmulator(auth, REACT_APP_FIRESTORE_AUTH_EMULATOR_HOST);

    console.log('Connecting to Firestore emulator...');
    connectFirestoreEmulator(db, 'localhost', 8080);
    console.log('Connected to Firestore emulator');

    //  Sign in with dummy user in emulator
    signInWithEmailAndPassword(auth, 'dummy.user@randstad.com', 'password')
        .then((userCredential) => {
            console.log('Dummy user signed in:', userCredential.user);
            // Initialize Firestore data after authentication
            initializeFirestoreData().catch((error) => {
                console.error('!!!!!!!!Error initializing Firestore data:', error);
            });
        })
        .catch((error) => {
            console.error('Error signing in with dummy user:', error);
            // Create dummy user in emulator
            createUserWithEmailAndPassword(auth, 'dummy.user@randstad.com', 'password')
                .then((userCredential) => {
                    console.log('Dummy user created:', userCredential.user);
                    // Initialize Firestore data after authentication
                    initializeFirestoreData().catch((error) => {
                        console.error('Error initializing Firestore data:', error);
                    });
                })
                .catch((error) => {
                    console.error('Error creating dummy user:', error);
                });
        });
    console.log('Connected to Auth emulator');
} else {
    // For production, initialize Firestore data without authentication
    initializeFirestoreData().catch((error) => {
        console.error('Error initializing Firestore data:', error);
    });
}

export { db };
console.debug('firebase db', db);

export { auth };

export const storage = getStorage(app);
export { analytics };
